import { render, staticRenderFns } from "./PopupAddStage.vue?vue&type=template&id=5e34e2c5&scoped=true&"
import script from "./PopupAddStage.vue?vue&type=script&lang=js&"
export * from "./PopupAddStage.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddStage.vue?vue&type=style&index=0&id=5e34e2c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e34e2c5",
  null
  
)

export default component.exports